import { render, staticRenderFns } from "./UserMassiveDeleteDrawer.vue?vue&type=template&id=1c4a4345&scoped=true"
import script from "./UserMassiveDeleteDrawer.vue?vue&type=script&lang=js"
export * from "./UserMassiveDeleteDrawer.vue?vue&type=script&lang=js"
import style0 from "./UserMassiveDeleteDrawer.vue?vue&type=style&index=0&id=1c4a4345&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4a4345",
  null
  
)

export default component.exports